export const NAME_TITLES = ['Mr', 'Mrs', 'Ms', 'Miss', 'Dr', 'Capt', 'Rev'];

//Like any regex vaidators for email, this one isn't perfect but should be good enough. This one is from here - https://www.owasp.org/index.php/OWASP_Validation_Regex_Repository
export const EMAIL_REGEX = /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/;
export const SAFE_TEXT_REGEX = /^$|^[a-zA-Z0-9 .-/-$@!%&+;:,'"*?/()#]+$/;
export const QFF_OR_EMPTY_REGEX = /(^$|^(([0-9]){10}|([0-9]){1,7})$)/;

// This is intentionally not a complete validation and misses various complex rules. It should prevent basic typos
// such as missing characters and be enough for someone with a valid ABN not to accidentally mistype it.
export const ABN_OR_EMPTY_REGEX = /(^$|^(\d){11}$)/;

export const CHECKOUT_PAGE_META = [
  { name: 'hotels-booking-stage', content: 'checkout' },
  { name: 'robots', content: 'noindex, follow' },
  { name: 'description', content: 'Review and Pay | Qantas Hotels Australia' },
];

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
